import { httpsCallable } from "firebase/functions";
import { cloudFunctions } from "./getFunctions";
import {
  SoporteAtiendo,
  CloudFunctionResponse,
  CallablesGeneral
} from "@fixeduy/restaurantestypes";

const soporteAtiendo = async (
  data: SoporteAtiendo
): Promise<CloudFunctionResponse> => {
  const run = httpsCallable<CallablesGeneral, CloudFunctionResponse>(
    cloudFunctions,
    "callablesGenerales"
  );
  const result = await run({
    func: "soporteAtiendo",
    params: data
  });
  return result.data;
};

export { soporteAtiendo };
